<div [formGroup]="formGroup">
    <dff-date-field
        id="aflaesningsDato"
        [formControl]="formGroup.controls.dato"
        placeholder="Dato for aflæsning"
        [required]="true"
        [max]="maxDate"
    >
    </dff-date-field>
    <maaler-aflaesning [formGroup]="formGroup.get('aflaesning')"></maaler-aflaesning>
</div>
